import { render } from "./InvitationDrawer.vue?vue&type=template&id=2f988548"
import script from "./InvitationDrawer.vue?vue&type=script&lang=js"
export * from "./InvitationDrawer.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__